import { environment } from '../environments/environment';

export const APP: any = {
    ApiEndpoint: environment.ApiEndpoint,
    AppBaseUrl: environment.AppBaseUrl,
    urlViewDocumentoDian: environment.urlViewDocumentoDian,
    ApiDianEndpoind: environment.ApiDianEndpoind,
    ApiKey: environment.ApiKey
}
